import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import MUIBreadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import { LinkProps, Link as RouterLink, useLocation } from 'react-router';
import { StyleObj } from '../../@types';
import { isUUID } from '../../helpers';
import { formatBreadcrumb } from '../../utils';
import theme from '../../styles/theme';
import { useBreakpoints } from '../../hooks/useBreakpoints';

interface LinkRouterProps extends LinkProps {
  to: string;
  replace?: boolean;
}

const styles: StyleObj = {
  breadcrumbs: {
    px: {
      xs: 2,
      md: 0,
    },
    textTransform: 'capitalize',
    color: 'text.primary',
    '& .MuiBreadcrumbs-separator': {
      mx: 0.5,
      mb: -0.25,
    },
    '& .MuiSvgIcon-root': {
      fontSize: '1rem',
      [theme.breakpoints.down('sm')]: {
        fontSize: '0.75rem',
      },
    },
  },
  link: {
    fontWeight: 600,
    letterSpacing: '0.1px',
  },
};

const LinkRouter = (props: LinkRouterProps) => {
  return <Link {...props} component={RouterLink} underline='hover' variant='h6' sx={styles.link} />;
};

const Breadcrumbs = () => {
  const location = useLocation();
  const crumbs = window.location.pathname.split('/').filter(Boolean);

  const { isMobile } = useBreakpoints();

  const isHomePage = location.pathname === '/';

  return (
    <MUIBreadcrumbs
      maxItems={isMobile ? 3 : undefined}
      separator={<ChevronRightIcon />}
      aria-label='breadcrumbs'
      sx={styles.breadcrumbs}
    >
      {!isHomePage && (
        <LinkRouter color='inherit' to='/'>
          Dashboard
        </LinkRouter>
      )}
      {crumbs.map((crumb, index) => {
        const to = `/${crumbs.slice(0, index + 1).join('/')}`;

        if (isUUID(crumb)) return null;

        return (
          <LinkRouter color='inherit' to={to} key={to}>
            {formatBreadcrumb(crumb)}
          </LinkRouter>
        );
      })}
    </MUIBreadcrumbs>
  );
};

export default Breadcrumbs;
